// Maps the current URL to a registered page, using the localized slugs in the registry.

import { resolvePageKey } from '/shared/utils/core/url.js';

export default class PageRouter {
  /**
   * @param {object} registry the full PAGE_REGISTRY object
   */
  constructor(registry) {
    this.registry = registry;
  }

  /**
   * Resolve a pathname + language to a page descriptor.
   * @param {string} pathname
   * @param {string} lang
   * @returns {object|null} the page entry (with key) or null if no page matches
   */
  resolve(pathname, lang) {
    const key = resolvePageKey(this.registry, pathname, lang);
    return key ? { key, ...this.registry.pages[key] } : null;
  }
}
